<style
  lang="less"
  scoped="">
  .footer {
    min-height: 160px;
    p {
      text-align: center;
      margin-top: 10px;
      color: #666;
    }
  }

  .footer_list {
    width: 480px;
    margin: 30px auto 10px auto;
    display: flex;
    justify-content: space-between;
    li {
      padding-bottom: 10px;
      padding-top: 10px;
    }
    a {
      color: #999;
    }
  }

</style>

<template>
  <div class="footer">
    <ul class="footer_list">
      <li v-for="item in aboutus">
        <router-link :to="{ name: item.href, params: { liName: item.liName }}">{{ item.name }}</router-link>
      </li>
    </ul>
    <div class="clearfix"></div>
    <p>Copyright @ 2015-2019 www.qiyewan.com 上海知加信息科技有限公司</p>
    <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号：沪ICP备15043250号-2</a></p>
  </div>

</template>

<script>
  export default {
    data () {
      return {
        aboutus: [
          {
            name: '关于我们',
            href: 'about-us',
            liName: 'about'
          },
          // {
          //   name: '加入我们',
          //   href: 'recruitment',
          //   liName: '',
          // },
          {
            name: '索要发票',
            href: 'about-us',
            liName: 'invoice'
          },
          {
            name: '退款说明',
            href: 'about-us',
            liName: 'refund'
          },
          {
            name: '支付方式',
            href: 'about-us',
            liName: 'pay'
          },
          {
            name: '联系我们',
            href: 'about-us',
            liName: 'contact'
          },
          {
            name: '用户协议',
            href: 'about-us',
            liName: 'protocol'
          }
        ],

      }
    },
    props: {},
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?fbbe5b96